import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, palette, themeMode, variant, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import Popover from '../Popover/Popover.es.js';
import '../Popover/PopoverContext.es.js';
var navDirectionStyles = variant({
  prop: "isVertical",
  variants: {
    false: {
      flexDirection: "row"
    },
    true: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  }
});
var navVariantStyles = variant({
  prop: "variant",
  variants: {
    tab: {
      "&:after": {
        content: '""',
        position: "absolute",
        zIndex: 1,
        width: "100%",
        height: "1px",
        left: 0,
        bottom: 0,
        backgroundColor: themeMode({
          light: palette("neutral.300"),
          dark: palette("neutral.600")
        })
      }
    },
    pill: {
      gap: "sm"
    },
    default: {
      gap: "xs"
    }
  }
});
var Nav = styled(Box).withConfig({
  componentId: "sc-1rwj3yw-0"
})(["position:relative;flex:1 1 auto;display:flex;align-items:center;margin:0;width:100%;max-width:100%;min-width:0;", ";", ";"], navDirectionStyles, navVariantStyles);
var NavList = styled(Box).withConfig({
  componentId: "sc-1rwj3yw-1"
})(["display:flex;align-items:center;margin:0;", ";", ";"], navDirectionStyles, navVariantStyles);
var NavItem = styled(Box).withConfig({
  componentId: "sc-1rwj3yw-2"
})([""]);
var navLinkVariants = variant({
  prop: "variant",
  variants: {
    default: {
      ':not([aria-current="true"])': {
        color: themeMode({
          light: "neutral.500",
          dark: "neutral.400"
        })
      },
      fontWeight: "bold",
      "&:hover": {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      },
      '&:active, &[aria-current="true"]': {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }
    },
    pill: {
      fontWeight: "bold",
      borderRadius: "round",
      color: themeMode({
        light: "neutral.900",
        dark: "neutral.50"
      }),
      backgroundColor: themeMode({
        light: "neutral.100",
        dark: "neutral.800"
      }),
      "&:hover": {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        }),
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.700"
        })
      },
      '&:active, &[aria-current="true"]': {
        color: themeMode({
          light: "neutral.50",
          dark: "neutral.900"
        }),
        backgroundColor: themeMode({
          light: "neutral.700",
          dark: "neutral.200"
        })
      }
    },
    tab: {
      position: "relative",
      ':not([aria-current="true"])': {
        color: themeMode({
          light: "neutral.500",
          dark: "neutral.400"
        })
      },
      fontWeight: "bold",
      "&:hover": {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      },
      "&:focus-visible": {
        outline: 0,
        boxShadow: "none"
      },
      "&:after": {
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        opacity: 0,
        transition: "opacity 200ms ease-in",
        borderWidth: "3px",
        borderStyle: "solid",
        borderColor: "" + color("border.base"),
        borderTopLeftRadius: "lg",
        borderTopRightRadius: "lg"
      },
      "&:focus-visible:after": {
        opacity: 1
      },
      '&:active, &[aria-current="true"]': {
        zIndex: 2,
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        }),
        "&:before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "3px",
          bottom: 0,
          left: 0,
          backgroundColor: themeMode({
            light: "neutral.900",
            dark: "neutral.50"
          })
        }
      }
    }
  }
});
var navLinkSizes = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      lineHeight: "24px",
      py: "xxs",
      px: "xs"
    },
    md: {
      fontSize: "md",
      lineHeight: "24px",
      py: "xs",
      px: "sm"
    },
    lg: {
      fontSize: "lg",
      lineHeight: "24px",
      py: "sm",
      px: "md"
    }
  }
});
var navLinkSizesMobile = variant({
  prop: "size",
  variants: {
    md: {
      px: "md"
    }
  }
});

var getBadgePadding = function getBadgePadding(size) {
  switch (size) {
    case "lg":
      return spacing("sm");

    case "md":
      return spacing("xs");

    case "sm":
      return spacing("xxs");

    default:
      return void 0;
  }
};

var NavLink = styled(Box).withConfig({
  componentId: "sc-1rwj3yw-3"
})(["display:flex;align-items:center;text-decoration:none;cursor:pointer;white-space:nowrap;z-index:1;", ";", ";padding-right:", ";", ""], navLinkVariants, navLinkSizes, function (_ref) {
  var hasBadge = _ref.hasBadge,
      size = _ref.size;

  if (hasBadge) {
    return getBadgePadding(size);
  }

  return void 0;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint("md")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n       ", ";\n       min-height: 48px;\n    "])), navLinkSizesMobile);
});
styled(Popover.Content).withConfig({
  componentId: "sc-1rwj3yw-4"
})(["padding-left:0;padding-right:0;", "{flex:1 1 auto;padding:", " ", ";&:hover{color:", ";background-color:", ";}&:active{color:", ";background-color:", ";}}", "{padding:", " ", ";}"], NavLink, spacing("xs"), spacing("md"), palette("text.base"), themeMode({
  light: palette("neutral.100"),
  dark: palette("neutral.700")
}), palette("text.base"), themeMode({
  light: palette("neutral.100"),
  dark: palette("neutral.600")
}), NavItem, spacing("xs"), spacing("md"));
export { Nav, NavItem, NavLink, NavList };